export enum PickupStatus {
    Requested = 1,
	Confirmed = 2,
    Cancelled = 3,
    CheckedIn = 4,
    DriverNotified = 5,
    Fulfilled = 6,
    NotFulFilled = 7,
}